import brandPortalOrders from "@faire/web-api/routes/brand-portal/orders";
import brandPortalOrdersbrandOrderToken from "@faire/web-api/routes/brand-portal/orders/brandOrderToken";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
export var CancelOrderIA = function CancelOrderIA(_ref) {
  var _context$brandOrder, _context$brandOrder$b;
  var context = _ref.context;
  var brandOrderToken = (_context$brandOrder = context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b = _context$brandOrder.brand_order) === null || _context$brandOrder$b === void 0 ? void 0 : _context$brandOrder$b.token;
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "4agNLN",
    defaultMessage: [{
      "type": 0,
      "value": "Les commandes peuvent être annulées dans certaines circonstances avant qu'elles atteignent certaines étapes du traitement. Vous trouverez plus d'informations sur le motif d'annulation d'une commande spécifique sur la "
    }, {
      "children": [{
        "type": 0,
        "value": "page des détails de la commande"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }, {
      "type": 0,
      "value": " et dans le calendrier de cette commande. Voici un aperçu des situations dans lesquelles une commande peut être annulée."
    }],
    values: {
      LinkFormatting: function LinkFormatting(chunks) {
        return OrderLinkFormatting(chunks, brandOrderToken);
      }
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "8z47MZ",
    defaultMessage: [{
      "type": 0,
      "value": "Tout d'abord, vous pouvez annuler les commandes non exécutées si vous ne pouvez pas les honorer pour certaines raisons, telles que des problèmes de stock ou des conflits d'exclusivité."
    }],
    values: {
      LinkFormatting: function LinkFormatting(chunks) {
        return OrderLinkFormatting(chunks, brandOrderToken);
      }
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "4ZAq1R",
    defaultMessage: [{
      "type": 0,
      "value": "Les commerçants disposent d'un délai de 24 heures pour annuler une nouvelle commande, tant qu'elle n'a pas été acceptée par la marque. Passé ce délai, ou après que vous avez accepté la commande, la demande d'annulation d'un commerçant vous sera transmise. Vous aurez la possibilité de l'accepter ou de la refuser."
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "7c/yYT",
    defaultMessage: [{
      "type": 0,
      "value": "Enfin, les commandes peuvent être automatiquement annulées par Faire en cas de retard important dans leur traitement. Cela peut se produire si vous ne saisissez pas une date d'expédition prévue pour une nouvelle commande dans les 30 jours ou si vous ne fournissez pas d'informations de suivi pour une commande acceptée dans les 30 jours suivant la date d'expédition indiquée."
    }]
  })));
};
var OrderLinkFormatting = function OrderLinkFormatting(chunks, brandOrderToken) {
  if (!brandOrderToken) {
    return /*#__PURE__*/React.createElement(Button, {
      variant: "tertiary",
      linkTo: brandPortalOrders(),
      target: "_blank"
    }, /*#__PURE__*/React.createElement(Bold, null, chunks));
  } else {
    return /*#__PURE__*/React.createElement(Button, {
      variant: "tertiary",
      linkTo: brandPortalOrdersbrandOrderToken(brandOrderToken),
      target: "_blank"
    }, /*#__PURE__*/React.createElement(Bold, null, chunks));
  }
};